import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/app/src/base/component/analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/base/component/react-query.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/base/provider/hero.provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/globals.css");
